
import {define} from "observable:runtime";
import asset1 from "../style.css?url";

const assets = new Map([
  ["../style.css", asset1]
]);

define(
  {
    root: document.getElementById(`cell-2`),
    expanded: [],
    variables: []
  },
  {
    id: 2,
    body: async (html,display) => {
const {createUI, installHashImportBanner, installThemeToggle} = await import("../lib/helpers.js").then((module) => {
  if (!("createUI" in module)) throw new SyntaxError(`export 'createUI' not found`);
  if (!("installHashImportBanner" in module)) throw new SyntaxError(`export 'installHashImportBanner' not found`);
  if (!("installThemeToggle" in module)) throw new SyntaxError(`export 'installThemeToggle' not found`);
  return module;
});
installThemeToggle({ html, display });
installHashImportBanner({ html, display });
const { codeEditor, canvasOutput, canvasTest, canvasTestReport } = createUI({ html });
return {createUI,installHashImportBanner,installThemeToggle,codeEditor,canvasOutput,canvasTest,canvasTestReport};
},
    inputs: ["html","display"],
    outputs: ["createUI","installHashImportBanner","installThemeToggle","codeEditor","canvasOutput","canvasTest","canvasTestReport"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-5`),
    expanded: [],
    variables: []
  },
  {
    id: 5,
    body: (view,codeEditor) => {
const code_set = view(codeEditor("canvas:colors-set", {
  value: `ctx.fillStyle = "rgb(255, 0, 0)"    // Rot wählen
ctx.fillRect(50, 50, 100, 100)        // Rotes Rechteck

ctx.strokeStyle = "rgb(0, 128, 0)"  // Grün wählen
ctx.lineWidth = 4
ctx.strokeRect(200, 50, 100, 100)     // Grüner Umriss`
}));
return {code_set};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_set"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-6`),
    expanded: [],
    variables: []
  },
  {
    id: 6,
    body: (display,canvasOutput,code_set) => {
display(canvasOutput(code_set, { width: 400, height: 220 }));
},
    inputs: ["display","canvasOutput","code_set"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-8`),
    expanded: [],
    variables: []
  },
  {
    id: 8,
    body: (view,codeEditor) => {
const code_brush = view(codeEditor("canvas:colors-brush", {
  value: `ctx.fillStyle = "rgb(255, 0, 0)";   // Pinsel in Rot tauchen
ctx.fillRect(50, 50, 100, 100);      // Rotes Rechteck
ctx.fillRect(200, 50, 100, 100);     // Noch ein rotes Rechteck!

ctx.fillStyle = "rgb(0, 0, 255)";   // Pinsel in Blau tauchen
ctx.fillRect(125, 125, 100, 100);     // Blaues Rechteck`
}));
return {code_brush};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_brush"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-9`),
    expanded: [],
    variables: []
  },
  {
    id: 9,
    body: (display,canvasOutput,code_brush) => {
display(canvasOutput(code_brush, { width: 350, height: 350 }));
},
    inputs: ["display","canvasOutput","code_brush"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-11`),
    expanded: [],
    variables: []
  },
  {
    id: 11,
    body: (view,codeEditor) => {
const code_rgba = view(codeEditor("canvas:colors-rgba", {
  value: `ctx.fillStyle = "rgb(255, 0, 0)"
ctx.fillRect(50, 50, 150, 150)

ctx.fillStyle = "rgba(0, 0, 255, 0.5)"  // 50 % transparentes Blau
ctx.fillRect(100, 100, 150, 150)          // überlappt das rote`
}));
return {code_rgba};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_rgba"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-12`),
    expanded: [],
    variables: []
  },
  {
    id: 12,
    body: (display,canvasOutput,code_rgba) => {
display(canvasOutput(code_rgba, { width: 320, height: 300 }));
},
    inputs: ["display","canvasOutput","code_rgba"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-14`),
    expanded: [],
    variables: []
  },
  {
    id: 14,
    body: (view,codeEditor) => {
const code_ex1 = view(codeEditor("canvas:colors-ex1", {
  value: `// Tipp: rgba(R, G, B, 0.7)
`
}));
return {code_ex1};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_ex1"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-15`),
    expanded: [],
    variables: []
  },
  {
    id: 15,
    body: (display,canvasOutput,code_ex1) => {
display(canvasOutput(code_ex1, { width: 360, height: 320 }));
},
    inputs: ["display","canvasOutput","code_ex1"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-16`),
    expanded: [],
    variables: []
  },
  {
    id: 16,
    body: (display,canvasTestReport,canvasTest,code_ex1) => {
display(canvasTestReport(canvasTest(code_ex1, {
  width: 360, height: 320,
  checks: [
    { name: "Drei Rechtecke gezeichnet", run: ({ base }) => {
        const n = base.callsTo("fillRect").length;
        return { passed: n >= 3, detail: `${n} gezeichnet` };
    } },
    { name: "Mit Transparenz (rgba, Alpha < 1)", run: ({ base }) => {
        const hit = base.setsOf("fillStyle").map(String).some(s => {
          const m = s.match(/rgba\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*,\s*([\d.]+)\s*\)/i);
          return m && parseFloat(m[1]) < 1;
        });
        return { passed: hit, detail: hit ? null : "nutze rgba(R, G, B, 0.7)" };
    } },
    { name: "Quadrate überlappen sich", run: ({ base }) => {
        const r = base.callsTo("fillRect").map(c => c.args);
        const ov = (a, b) => a[0] < b[0] + b[2] && b[0] < a[0] + a[2] &&
                             a[1] < b[1] + b[3] && b[1] < a[1] + a[3];
        for (let i = 0; i < r.length; i++)
          for (let j = i + 1; j < r.length; j++)
            if (ov(r[i], r[j])) return true;
        return false;
    } }
  ]
}), "Übung 1"));
},
    inputs: ["display","canvasTestReport","canvasTest","code_ex1"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-18`),
    expanded: [],
    variables: []
  },
  {
    id: 18,
    body: (view,codeEditor) => {
const code_ex2 = view(codeEditor("canvas:colors-ex2", {
  value: ``
}));
return {code_ex2};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_ex2"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-19`),
    expanded: [],
    variables: []
  },
  {
    id: 19,
    body: (display,canvasOutput,code_ex2) => {
display(canvasOutput(code_ex2, { width: 320, height: 320 }));
},
    inputs: ["display","canvasOutput","code_ex2"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-20`),
    expanded: [],
    variables: []
  },
  {
    id: 20,
    body: (display,canvasTestReport,canvasTest,code_ex2) => {
display(canvasTestReport(canvasTest(code_ex2, {
  width: 320, height: 320,
  checks: [
    { name: "Dunkles Feld unten links", run: ({ base }) => {
        const p = base.pixel(20, 300);
        const lum = (p[0] + p[1] + p[2]) / 3;
        return { passed: lum < 150, detail: `Helligkeit ${Math.round(lum)}` };
    } },
    { name: "Lückenloses 8 × 8 Schachbrett", run: ({ base }) => {
        const size = 40;   // 320 / 8 — die Felder müssen das Brett ohne Lücken füllen
        const lum = (x, y) => { const p = base.pixel(x, y); return (p[0] + p[1] + p[2]) / 3; };
        // Unten links muss dunkel sein → das legt fest, welche Parität dunkel ist.
        if (lum(20, 7 * size + 20) >= 128) return { passed: false, detail: "unten links ist nicht dunkel" };
        const darkParity = (0 + 7) % 2;
        let bad = 0, checked = 0;
        for (let col = 0; col < 8; col++) for (let row = 0; row < 8; row++) {
          const expectDark = ((col + row) % 2) === darkParity;
          // Mitte UND Nähe der Feldkante prüfen — so fallen zu kleine Felder
          // (z. B. fillRect(x, y, 40, 30)) durch ihre Lücken auf.
          for (const [ox, oy] of [[20, 20], [32, 34]]) {
            const isDark = lum(col * size + ox, row * size + oy) < 128;
            checked++;
            if (isDark !== expectDark) bad++;
          }
        }
        return { passed: bad === 0, detail: bad ? `${bad}/${checked} Stellen falsch — Lücken oder falsche Feldgröße?` : null };
    } }
  ]
}), "Übung 2"));
},
    inputs: ["display","canvasTestReport","canvasTest","code_ex2"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-22`),
    expanded: [],
    variables: []
  },
  {
    id: 22,
    body: (display,canvasOutput) => {
display(canvasOutput(`function drawSquareWithBorder(x, y, width, height, strokeSize, fillColor, strokeColor) {
  ctx.fillStyle = strokeColor
  ctx.fillRect(x, y, width, height)
  ctx.fillStyle = fillColor
  ctx.fillRect(x + strokeSize, y + strokeSize, width - strokeSize * 2, height - strokeSize * 2)
}

drawSquareWithBorder(10, 10, 100, 100, 10, "red", "black")
drawSquareWithBorder(100, 10, 100, 100, 10, "green", "white")
drawSquareWithBorder(10, 110, 90, 90, 4, "blue", "red")
drawSquareWithBorder(100, 100, 100, 100, 0, "yellow", "black")`, { width: 300, height: 300 }));
},
    inputs: ["display","canvasOutput"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-23`),
    expanded: [],
    variables: []
  },
  {
    id: 23,
    body: (view,codeEditor) => {
const code_ex3 = view(codeEditor("canvas:colors-ex3", {
  value: ``
}));
return {code_ex3};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_ex3"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-24`),
    expanded: [],
    variables: []
  },
  {
    id: 24,
    body: (display,canvasOutput,code_ex3) => {
display(canvasOutput(code_ex3, { width: 300, height: 300 }));
},
    inputs: ["display","canvasOutput","code_ex3"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-25`),
    expanded: [],
    variables: []
  },
  {
    id: 25,
    body: (display,canvasTestReport,canvasTest,code_ex3) => {
const isRed = (r, g, b) => r > 150 && g < 90 && b < 90;
const isGreen = (r, g, b) => g > 90 && r < 120 && b < 120;
const isBlue = (r, g, b) => b > 150 && r < 90 && g < 90;
const isYellow = (r, g, b) => r > 150 && g > 150 && b < 90;
const isBlack = (r, g, b) => r < 60 && g < 60 && b < 60;
// Liest einen Pixel aus einem Probe-Ergebnis als [r, g, b].
const px3 = (p, x, y) => { const [r, g, b] = p.pixel(x, y); return [r, g, b]; };
// Ruft die Funktion mit Test-Parametern auf einem frischen Canvas auf. Da der
// Aufruf NACH dem Code des Schülers passiert, „gewinnt“ unser Quadrat überall,
// wo wir hineinschauen — deshalb prüfen wir nur Pixel innerhalb des Quadrats.
display(canvasTestReport(canvasTest(code_ex3, {
  width: 300, height: 300, extract: "drawSquareWithBorder",
  checks: [
    { name: "Funktion `drawSquareWithBorder` existiert", run: ({ base }) =>
        ({ passed: base.fnFound, detail: base.fnFound ? null : "Funktion `drawSquareWithBorder` nicht gefunden" }) },

    // --- Das Zielbild aus genau vier Aufrufen (exakte Positionen) ---
    { name: "Rotes Quadrat mit schwarzem Rand bei (10, 10)", run: ({ base }) => {
        const ok = isRed(...px3(base, 60, 60)) && isBlack(...px3(base, 14, 14));
        return { passed: ok, detail: ok ? null : "rotes Quadrat oder sein schwarzer Rand fehlt / falsch platziert" };
    } },
    { name: "Grünes Quadrat mit weißem Rand bei (100, 10)", run: ({ base }) => {
        const ok = isGreen(...px3(base, 150, 60));
        return { passed: ok, detail: ok ? null : "grünes Quadrat fehlt / falsch platziert" };
    } },
    { name: "Blaues Quadrat (90 × 90) mit rotem Rand bei (10, 110)", run: ({ base }) => {
        const ok = isBlue(...px3(base, 55, 155)) && isRed(...px3(base, 12, 150));
        return { passed: ok, detail: ok ? null : "blaues Quadrat oder sein roter Rand fehlt / falsch platziert" };
    } },
    { name: "Gelbes Quadrat ohne Rand bei (100, 100)", run: ({ base }) => {
        const ok = isYellow(...px3(base, 150, 150)) && isYellow(...px3(base, 103, 103));
        return { passed: ok, detail: ok ? null : "gelbes Quadrat fehlt, falsch platziert oder hat einen Rand" };
    } },

    // --- Die Funktion direkt mit Parametern testen ---
    { name: "füllt das Innere mit `fillColor`", run: ({ probe }) => {
        const p = probe({ callArgs: [40, 40, 120, 120, 15, "red", "black"] });
        const [r, g, b] = px3(p, 100, 100);   // Mitte
        return { passed: isRed(r, g, b), detail: isRed(r, g, b) ? null : "die Mitte ist nicht in der Füllfarbe" };
    } },
    { name: "zeichnet den Rand in `strokeColor`", run: ({ probe }) => {
        const p = probe({ callArgs: [40, 40, 120, 120, 15, "red", "black"] });
        const [r, g, b] = px3(p, 43, 100);    // im Randband (x 40..55)
        return { passed: isBlack(r, g, b), detail: isBlack(r, g, b) ? null : "der Rand ist nicht in der Randfarbe" };
    } },
    { name: "beachtet die Randdicke `strokeSize`", run: ({ probe }) => {
        const p = probe({ callArgs: [40, 40, 120, 120, 15, "red", "black"] });
        const band = px3(p, 43, 100);    // innerhalb des 15px-Randes → Randfarbe
        const inner = px3(p, 70, 100);   // klar in der Füllung → Füllfarbe
        const ok = isBlack(...band) && isRed(...inner);
        return { passed: ok, detail: ok ? null : "Rand und Füllung passen nicht zur Randdicke" };
    } },
    { name: "ohne Rand (`strokeSize = 0`) keine Randfarbe", run: ({ probe }) => {
        const p = probe({ callArgs: [40, 40, 120, 120, 0, "green", "black"] });
        const [r, g, b] = px3(p, 42, 100);    // direkt am Quadratrand
        return { passed: isGreen(r, g, b), detail: isGreen(r, g, b) ? null : "auch mit strokeSize = 0 erscheint ein Rand" };
    } },
    { name: "beachtet die Position `x`, `y`", run: ({ probe }) => {
        const p = probe({ callArgs: [170, 30, 80, 80, 8, "blue", "black"] });
        const [r, g, b] = px3(p, 210, 70);    // Mitte von (170, 30) + 80/2
        return { passed: isBlue(r, g, b), detail: isBlue(r, g, b) ? null : "das Quadrat sitzt nicht an (x, y)" };
    } },
    { name: "beachtet `width` und `height` getrennt", run: ({ probe }) => {
        // breites, flaches Rechteck: x 40..200, y 40..120
        const p = probe({ callArgs: [40, 40, 160, 80, 10, "red", "black"] });
        const center = px3(p, 120, 80);       // Mitte → Füllung
        const rightEdge = px3(p, 196, 80);    // rechter Rand bei x≈200 (width = 160)
        const bottomEdge = px3(p, 120, 116);  // unterer Rand bei y≈120 (height = 80)
        const ok = isRed(...center) && isBlack(...rightEdge) && isBlack(...bottomEdge);
        return { passed: ok, detail: ok ? null : "Breite und/oder Höhe werden nicht korrekt verwendet" };
    } }
  ]
}), "Übung 3"));
return {isRed,isGreen,isBlue,isYellow,isBlack,px3};
},
    inputs: ["display","canvasTestReport","canvasTest","code_ex3"],
    outputs: ["isRed","isGreen","isBlue","isYellow","isBlack","px3"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
